module.exports = __webpack_public_path__ + "img/ic-reload.0589d686.svg";